import React, { Component } from "react";
import PropTypes from "prop-types";
import $ from "jquery";
import "./ReadMore.scss";
// import isEqual from "lodash/isEqual";

const VK_ENTER = 13;

/**
 * ReadMore
 */
class ReadMore extends Component {
  static propTypes = {
    children: PropTypes.node,
    moreText: PropTypes.node,
    lessText: PropTypes.node,
    className: PropTypes.string,
    onToggle: PropTypes.func,
    isExpanded: PropTypes.bool,
    isAutoExpandedMQ: PropTypes.string
    // minHeight: PropTypes.number,
  };

  static defaultProps = {
    children: null,
    moreText: "Read more >>> ",
    lessText: "Read less <<< ",
    className: null,
    onToggle: null,
    isExpanded: false,
    isAutoExpandedMQ: ""
    // minHeight: 120,
  };

  state = {
    toggled: false,
    minHeight: 90
  };

  componentDidMount() {
    const $el = $(".ReadMore__Content");

    const $boldEl = $el.find("b,strong").first();
    if (!$boldEl.length) {
      return;
    }
    const minHeight = $boldEl.offset().top - $boldEl.parents(".ReadMore").offset().top + $boldEl.height();

    let { isExpanded } = this.props;
    if (this.props.isAutoExpandedMQ && window.matchMedia) {
      isExpanded = window.matchMedia(`(${this.props.isAutoExpandedMQ})`).matches;
    }
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ minHeight, toggled: isExpanded });
  }

  componentWillReceiveProps(props) {
    if (this.props.isExpanded !== props.isExpanded) {
      this.setState({ toggled: props.isExpanded });
    }
  }

  onToggle = e => {
    if (this.props.onToggle) {
      this.props.onToggle(e);
      return false;
    }
    if (e.keyCode && e.keyCode !== VK_ENTER) {
      return true;
    }
    this.setState({
      toggled: !this.state.toggled
    });
    return false;
  };

  getStyle = () => {
    if (!this.state.minHeight) {
      return {};
    }
    return {
      minHeight: this.state.minHeight
    };
  };

  render() {
    const classes = ["ReadMore", this.props.className].filter(v => !!v);

    const isExpanded = this.state.toggled;

    return (
      <div className={classes.join(" ")}>
        <div
          style={this.getStyle()}
          className={`ReadMore__Content${isExpanded ? "" : " ReadMore__Content--collapsed"}`}
        >
          {this.props.children}
        </div>
        <br />
        <a className="ReadMore__Toggle" onClick={this.onToggle} onKeyDown={this.onToggle} role="button" tabIndex="-1">
          {isExpanded ? this.props.lessText : this.props.moreText}
        </a>
      </div>
    );
  }
}

export default ReadMore;
